import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal';
import ConfirmMessageContent from './ConfirmMessageContent';

export const ConfirmMessageModal = React.forwardRef((props, ref) => {
  return (
    <Modal ref={ref} {...props} className='modal-info-type'>
      <ConfirmMessageContent {...props}/>
    </Modal>
  );
});

ConfirmMessageModal.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
};

export default ConfirmMessageModal;
